import { __awaiter, __generator } from "tslib";
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logFeature } from '@office-start/telemetry-service';
import { getCachedEdgeworthDb } from './EdgeworthDb';
import { getTopCachedData } from './getTopCachedData';
export function getInstrumentedTopCachedData() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var result, params, logEvent, start, latency, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    result = undefined;
                    params = {};
                    logEvent = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    start = performance.now();
                    return [4 /*yield*/, getTopCachedData(getCachedEdgeworthDb())];
                case 2:
                    result = _b.sent();
                    latency = Math.ceil(performance.now() - start);
                    if (result && result.length > 0) {
                        params['State'] = 'Succeeded';
                        params['ActualSize'] = result.length.toString();
                        params['Latency'] = latency.toString() || '';
                        logEvent = true;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    params['State'] = 'Failed';
                    params['Error'] = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.toString) === null || _a === void 0 ? void 0 : _a.call(error_1)) || '';
                    logEvent = true;
                    return [3 /*break*/, 4];
                case 4:
                    if (logEvent) {
                        logGenericEvent(KnownInstrumentationEvents.EdgeworthCacheRead, params);
                        // TODO: Remove above Aria logging after fully migrating to OTEL
                        logFeature({
                            featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
                            eventName: 'EdgeworthCacheRead',
                            params: params,
                            area: 'Edgeworth',
                        });
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
//# sourceMappingURL=getInstrumentedTopCachedData.js.map